import { NavSchema } from './Nav.styles';

export const navStyles: NavSchema = {
  wrapper: { 
    spacing: '1', 
    pt: '2',
    sx: {
      '&[data-isonsportsall="true"]': {
        pb: '4',
        mb: '2',
        borderBottomWidth: '1px',
        borderBottomStyle: 'solid',
        borderColor: 'blackAlpha.400',
        borderRadius: 'none',
        boxShadow: '0 1px rgba(255, 255, 255, .07)',
      },
    },
  },
  link: {
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 'md',
    display: 'flex',
    flex: ['1', null, null, '0 1 auto'],
    pos: 'relative',
    px: '2.5',
    py: ['2.5', null, null, '5px'],
    textAlign: 'center',
    textTransform: 'uppercase',
    transitionDuration: 'normal',
    transitionProperty: 'common',
    zIndex: '1',
    lineHeight: 'tall',
    bgGradient: 'linear(to-b, alpha.400, alpha.600)',
    boxShadow:
      '0px 0px 0px 2px #FDD101 inset, 0px 0px 0px 4px #26830B inset, 0px 0px 0px 5px #89D255 inset, 0px 3px 7px 0px rgba(0, 0, 0, 0.45)',
    color: 'white',
    textShadow: '0px 1px 0px rgba(0, 0, 0, 0.25)',
    fontWeight: 'bold',
    fontSize: '2xs',
    sx: {
      '&.active': {
        bg: 'blackAlpha.500',
        color: 'delta.50',
        boxShadow: '0px 1px 0px 0px #000 inset',
        _before: {
          display: 'none',
        },
        _after: {
          display: 'none',
        },
        svg: {
          color: 'beta.500',
        },
      },
    },
  },
};
